'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defineProperty = require('../node_modules/@babel/runtime/helpers/esm/defineProperty.js');
var React = require('react');
require('prop-types');
var useUtilsCfb96ac9 = require('./useUtils-cfb96ac9.js');
var clsx_m = require('../node_modules/clsx/dist/clsx.m.js');
var makePickerWithState5a79cb8a = require('./makePickerWithState-5a79cb8a.js');
var Calendar11ae61f6 = require('./Calendar-11ae61f6.js');
var PickerCcd9ba90 = require('./Picker-ccd9ba90.js');
var makeStyles = require('../../core/esm/styles/makeStyles.js');

var useStyles = makeStyles({
  toolbar: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  toolbarLandscape: {
    padding: 16
  },
  dateLandscape: {
    marginRight: 16
  }
}, {
  name: 'MuiPickersDatePickerRoot'
});
var DatePickerToolbar = function DatePickerToolbar(_ref) {
  var date = _ref.date,
      views = _ref.views,
      setOpenView = _ref.setOpenView,
      isLandscape = _ref.isLandscape,
      openView = _ref.openView;
  var utils = useUtilsCfb96ac9.u();
  var classes = useStyles();
  var isYearOnly = React.useMemo(function () {
    return Calendar11ae61f6.i(views);
  }, [views]);
  var isYearAndMonth = React.useMemo(function () {
    return Calendar11ae61f6.b(views);
  }, [views]);
  return React.createElement(makePickerWithState5a79cb8a.P, {
    isLandscape: isLandscape,
    className: clsx_m(!isYearOnly && classes.toolbar, isLandscape && classes.toolbarLandscape)
  }, React.createElement(makePickerWithState5a79cb8a.T, {
    variant: isYearOnly ? 'h3' : 'subtitle1',
    onClick: function onClick() {
      return setOpenView('year');
    },
    selected: openView === 'year',
    label: utils.getYearText(date)
  }), !isYearOnly && !isYearAndMonth && React.createElement(makePickerWithState5a79cb8a.T, {
    variant: "h4",
    selected: openView === 'date',
    onClick: function onClick() {
      return setOpenView('date');
    },
    align: isLandscape ? 'left' : 'center',
    label: utils.getDatePickerHeaderText(date),
    className: clsx_m(isLandscape && classes.dateLandscape)
  }), isYearAndMonth && React.createElement(makePickerWithState5a79cb8a.T, {
    variant: "h4",
    onClick: function onClick() {
      return setOpenView('month');
    },
    selected: openView === 'month',
    label: utils.getMonthText(date)
  }));
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultProps = _objectSpread({}, PickerCcd9ba90.d, {
  openTo: 'date',
  views: ['year', 'date']
});

function useOptions(props) {
  var utils = useUtilsCfb96ac9.u();
  return {
    getDefaultFormat: function getDefaultFormat() {
      return Calendar11ae61f6.g(props.views, utils);
    }
  };
}

var DatePicker = makePickerWithState5a79cb8a.m({
  useOptions: useOptions,
  Input: makePickerWithState5a79cb8a.a,
  useState: makePickerWithState5a79cb8a.u,
  DefaultToolbarComponent: DatePickerToolbar
});
var KeyboardDatePicker = makePickerWithState5a79cb8a.m({
  useOptions: useOptions,
  Input: makePickerWithState5a79cb8a.K,
  useState: makePickerWithState5a79cb8a.b,
  DefaultToolbarComponent: DatePickerToolbar
});
DatePicker.defaultProps = defaultProps;
KeyboardDatePicker.defaultProps = defaultProps;

exports.DatePicker = DatePicker;
exports.KeyboardDatePicker = KeyboardDatePicker;
